<script setup lang="ts">
  import type { WysiwygMinimalStoryblok } from '@/storyblok/component-types-sb'
  import { marked } from 'marked'

  const props = defineProps<{
    blok: WysiwygMinimalStoryblok
  }>()

  const output = computed(() => marked(props.blok.content))
</script>

<template>
  <div
    class="only:[&_*]:m-0 [&_a]:text-inherit"
    v-html="output"
  />
</template>
